import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {useRepoIssuesSidebarPanes} from '@github-ui/repo-issues-page-layout/useRepoIssuesSidebarPanes'
import {ThreePanesLayout} from '@github-ui/three-panes-layout'
import {useEffect} from 'react'

import {renderIssuesSidebar} from '../../components/sidebar/render-issues-sidebar'
import {IssueViewsPage, RepositorySavedViewPage} from '../../lazy-routes'
import {preloadWhenIdle} from '../../utils/preload-when-idle'
import {AnalyticsWrapper} from '../AnalyticsWrapper'
import {RepositoryViewNewContent} from './RepositoryViewNewContent'

export function RepositoryViewNewPage() {
  useEffect(() => {
    return preloadWhenIdle(() => {
      IssueViewsPage.preload()
      RepositorySavedViewPage.preload()
    })
  }, [])

  // eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags -- issue_pinned_views uses actor-aware server-side evaluation via PinnedViewsFeature; isFeatureEnabled only knows current_user.
  const pinnedViewsEnabled = useFeatureFlag('issue_pinned_views')
  // eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags -- See above; issue_pinned_views_index_page is similarly actor-aware.
  const indexPageEnabled = useFeatureFlag('issue_pinned_views_index_page')
  const sidebarPanes = useRepoIssuesSidebarPanes(renderIssuesSidebar)
  if (!pinnedViewsEnabled || !indexPageEnabled) {
    return null
  }

  return (
    <AnalyticsWrapper category="Repository View New">
      <ThreePanesLayout
        contentAs="div"
        resizeable={false}
        leftPaneWidth="medium"
        collapsibleLeftPane={sidebarPanes.collapsibleLeftPane}
        middlePane={<RepositoryViewNewContent />}
      />
    </AnalyticsWrapper>
  )
}
